export default "__VITE_ASSET__CLABUakW__"